import colors from 'vuetify/util/colors'
import { ThemeDefinition } from 'vuetify'

const isLive = process.env.VUE_APP_ENV === 'master'

export const lightTheme: ThemeDefinition = {
    dark: false,
    colors: {
        black: '#000',
        background: '#f4f4f4',
        surface: colors.shades.white,
        'on-surface': '#232831',
        'surface-bright': colors.shades.white,
        'surface-light': colors.grey.lighten3,
        'surface-variant': colors.grey.darken3,
        'on-surface-variant': colors.grey.lighten3,
        primary: '#ff0059',
        active: '#ff0059',
        'primary-darken-1': '#d3034a',
        secondary: '#14465a',
        'secondary-darken-1': '#124052',
        error: '#B00020',
        info: colors.blue.base,
        success: colors.green.base,
        warning: colors.orange.darken1,
        staging: isLive ? '#ffff' : '#232831',
        silver: '#c0c0c0',
        gray: '#e3e3e3',
        white: '#fff',
        icon: '#5da2aa',
        indigo: colors.indigo.base,

        custom_color_1: '#B0B0B0',
        custom_color_2: '#76C2AF',
        custom_color_3: '#F3A842',
        custom_color_4: '#99CEFF',
        custom_color_5: '#F05E5E',
        custom_color_6: '#D9D9D9',
        custom_color_7: '#8DF8B4',
        custom_color_8: '#375EEB',
        custom_color_9: '#0EC2ED',
        custom_color_10: '#68D4E4',
        custom_color_11: '#58C8D8',
        custom_color_12: '#F4F4F4',
        custom_color_13: '#A1FF99',
        custom_color_14: '#6BE3A2',
        custom_color_15: '#E9E9E9',
        custom_color_16: '#3F8EEB',
        custom_color_17: '#7CDCC0',
        custom_color_18: '#777777',
        custom_color_19: '#6C6C6C',
        custom_color_20: '#3D1FDD',
        custom_color_21: '#03c503',
        custom_color_22: '#3434ee',
        custom_color_23: '#989800',
        custom_color_24: '#2cd5db',
        custom_color_25: '#ffc0cb',
        custom_color_26: '#F3BE72',
        custom_color_27: '#A5DBC5',
        custom_color_28: '#e7e7e7',
        custom_color_29: '#4CAF50',
        custom_color_30: '#F44336',
        custom_color_31: '#4B6081',
        custom_color_32: '#2d415f',
        custom_color_33: '#FBFBFB',
        custom_color_34: '#6539bb',
        custom_color_35: '#8c62ea',
        custom_color_36: '#d081ef',
        custom_color_37: '#394e5b',
        custom_color_38: '#d9d9d9',
        custom_color_39: '#4050B4',
        custom_color_40: '#EA3C39',
        custom_color_41: '#F98B2A',
        custom_color_42: '#AAB6EC',
        custom_color_43: '#F2A1E1',
        custom_color_44: '#888888',
        custom_color_45: '#dddddd',
        custom_color_46: '#828282',
        custom_color_47: '#2bc941',
        custom_color_48: '#ff3466',
        custom_color_49: '#747474',
        custom_color_50: '#20838f',
        custom_color_51: '#283593',
        custom_color_52: '#f6af43',
        custom_color_53: '#d0cfcf',
        custom_color_54: '#6366f1',
        custom_color_55: '#f2c24b',
        custom_color_56: '#6466e9',
        custom_color_57: '#434459',
    },
    variables: {
        'medium-emphasis-opacity': '1',
        'high-emphasis-opacity': '1',
    },
}

export const darkTheme: ThemeDefinition = {
    dark: true,
    colors: {
        black: '#fff',
        primary: '#ff0059',
        staging: isLive ? '#0000' : '#232831',

        custom_color_1: '#FF6F61',
        custom_color_2: '#6B8E23',
        custom_color_3: '#FFD700',
        custom_color_4: '#4682B4',
        custom_color_5: '#FF4500',
        custom_color_6: '#A9A9A9',
        custom_color_7: '#32CD32',
        custom_color_8: '#375EEB',
        custom_color_9: '#0EC2ED',
        custom_color_10: '#68D4E4',
        custom_color_11: '#58C8D8',
        custom_color_12: '#F4F4F4',
        custom_color_13: '#A1FF99',
    },
}
